// fetchUserIsBlocked.js
'use strict';
import 'isomorphic-fetch';

import getMeData from '../selector/getMeData.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import getResourceUrl from '../resource/getResourceUrl.js';

import {
  MERGE_USER,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch user is blocked
 * @kind action
 * @param {string} { userId } - user id for comfirm isBlocked.
 * @return {Promise} Action promise.
 */
const fetchUserIsBlocked =
  ({ userId }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!token || !userId) return;

    const selectPath = [userId, 'isBlocked'];

    const fetchOptions = {
      method: 'HEAD',
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };

    const url = getResourceUrl({ endpoint: '/me/blocking' });

    url.searchParams.append('id', userId);

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const totalCount = parseInt(response.headers.get('x-total-count'), 10);
      if (totalCount > 0) {
        dispatch({
          type: MERGE_USER,
          payload: { user: { id: userId, isBlocked: true } },
        });
      }

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchUserIsBlocked;
